import SelectAttribute from 'Components/attributes/SelectAttribute/Select'
import { ATTRIBUTE_TYPES } from 'Constants/attributes.constants'
import { ToolbarActionType } from 'Core/Workbench'
import { useState } from 'react'
import classes from '../ActionsContainer.module.less'

type DropdownActionsProps = {
    dropdownActions: ToolbarActionType[]
}

export const DropdownActions: React.FC<DropdownActionsProps> = (props: DropdownActionsProps) => {
    const { dropdownActions } = props

    const [selectedDropdownAction, setSelectedDropdownAction] = useState('Maker')

    const handleDropdownSelect = (selectedValue: string, index: number) => {
        const currentAction = dropdownActions[index]
        if (currentAction) {
            const option = currentAction.options?.find(opt => opt.value === selectedValue)
            if (option && currentAction?.onChange) {
                setSelectedDropdownAction(option.label)
                currentAction.onChange(option.value)
            }
        }
    }

    return (
        <>
            {dropdownActions.length > 0 &&
                dropdownActions.map((action, index) => (
                    <SelectAttribute
                        key={action.id}
                        id={'step-type'}
                        width={'120px'}
                        type={ATTRIBUTE_TYPES.SELECT}
                        className={classes.previewDropdownBtn}
                        value={selectedDropdownAction}
                        onChange={selectedValue =>
                            handleDropdownSelect(selectedValue as string, index)
                        }
                        options={
                            action?.options?.map(option => ({
                                label: option.label,
                                value: option.value,
                            })) ?? []
                        }
                        placeholder={`Select ${action.title}`}
                    />
                ))}
        </>
    )
}
